<template>
  <ContentSection>
    <Container>
      <h2
        v-if="data.heading"
        class="default-component-title mb-8 sm:mb-10"
        v-html="$replaceHtmlTags(data.heading)"
      />
      <AnimatedContainer>
        <ul class="grid grid-cols-2 gap-3 sm:gap-6 lg:grid-cols-4">
          <li
            v-for="(image, index) in data.images"
            :key="image.id"
            class="slide-in-left aspect-[32/33]"
            :class="{
              'col-span-2 row-span-2': index % 11 === 0,
            }"
          >
            <ImageDownloadable
              v-if="image"
              class="h-full w-full object-cover"
              :image="image"
              :downloadable="downloadableImages.includes(index + 1)"
              :aspect="32 / 33"
              :style="`object-position: ${image.focus_css};`"
            />
          </li>
        </ul>
      </AnimatedContainer>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
})

const downloadableImages = computed(() => {
  if (
    !props.data.images_downloadable &&
    typeof props.data.images_downloadable !== 'string'
  ) {
    return []
  }

  if (props.data.images_downloadable.toLowerCase() === 'alle') {
    return props.data.images.map((_, index) => index + 1)
  }

  return props.data.images_downloadable
    .replace(/\s/g, '')
    .split(',')
    .map(Number)
})
</script>
